import React, { useEffect, useState } from 'react';
import { useUIControlsStore } from '../../../redux';
import { FullScreenBackdropLoader } from '../../../fibe-ui';
import { useLocation, useNavigate } from 'react-router-dom';
import withDashboardMenuLayout from '../../../fibe-ui/layout/withDashboardMenuLayout';
import { LottieWrapper } from '../../../fibe-ui/index';
import Error from '../../../assets/suspend/error.json';

const NachCancellationTechnicalIssuePage = () => {
  const { updateHorizantalProgress, updateOnlyCrossIcon } =
    useUIControlsStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // DOCS: Clearing the state on encryption error
    // console.log('[INFO] Error in encryptTransform redux store: ', error);
    updateOnlyCrossIcon(true);
    updateHorizantalProgress({
      showHorizontalProgressBar: true,
      horizontalProgressBarProgress: 0,
    });
  }, []);

  return withDashboardMenuLayout({
    childComponent: (
      <>
        <FullScreenBackdropLoader isLoading={loading} />
        <div className={`h-screen lg:!h-[85vh] mobile:w-full`}>
          <div className="absolute p-6 bottom-4 flex flex-col">
            <LottieWrapper animationData={Error} width="150px" height="150px" />
            <span className="mt-5 font-headline font-bold text-[28px]">
              There is some technical issue
            </span>
            <span className="font-headline mt-3 font-semibold text-base text-text-secondary">
              Something went wrong, Please try again later
            </span>
            <button
              type="button"
              onClick={() => {
                navigate('/dashboard');
              }}
              className="w-[350px] mobile:w-full py-3 bg-accent text-white rounded-md shadow-lg font-headline mt-4 font-semibold text-base"
            >
              Okay, got it.
            </button>
          </div>
        </div>
      </>
    ),
    isLeftProgressBarPresent: false,
  });
};

export default NachCancellationTechnicalIssuePage;
